import { Logger } from "@devforce/trailhead-client-logger";
const PACKAGE_NAME = "@devforce/trailhead-client-events";
const logger = new Logger({
    prefix: `[${PACKAGE_NAME}]: `,
});
export class Emitter {
    constructor() {
        this.listeners = {};
    }
    on(event, listener) {
        var _a;
        this.listeners[event] = (_a = this.listeners[event]) !== null && _a !== void 0 ? _a : [];
        this.listeners[event].push(listener);
    }
    off(event, listener) {
        var _a;
        if (listener) {
            this.listeners[event] = ((_a = this.listeners[event]) !== null && _a !== void 0 ? _a : []).filter((l) => l !== listener);
        }
        else if (this === state.emitter) {
            logger.warn(`Cannot remove all listeners for type "${event.toString()}" on the shared emitter. You must include the handler along with the event type.`);
        }
        else {
            this.listeners[event] = [];
        }
    }
    emit(event, ...args) {
        var _a;
        for (let listener of (_a = this.listeners[event]) !== null && _a !== void 0 ? _a : []) {
            listener(...args);
        }
    }
}
export function getEmitter() {
    return state.emitter;
}
let state = {
    emitter: new Emitter(),
};
export function initializeState(currentState, existingState) {
    return existingState !== null && existingState !== void 0 ? existingState : currentState;
}
// This module may be executed multiple times from different sources
if (typeof window !== "undefined") {
    // @ts-ignore
    state = window[PACKAGE_NAME] = initializeState(state, window[PACKAGE_NAME]);
}
